import type { ReactNode } from "react";
import { connect } from "react-redux";

import actions from "@/actions";

import Button from "../base/Button";

const renderIcon = (color: string): ReactNode => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="29"
        height="33"
        viewBox="0 0 29 33"
    >
        <g fill="none" fillRule="evenodd" stroke={color} strokeLinecap="square">
            <path d="M21.473 2.76h6.956v29.217H.603V2.759H7.56" />
            <path d="M7.56 1.368v8.348h4.174a2.782 2.782 0 1 1 5.565 0h4.174V1.368H7.56z" />
        </g>
    </svg>
);

const Paste = (props: React.ComponentProps<typeof Button>) => (
    <Button {...props} renderIcon={renderIcon} />
);

const mapStateToProps = ({ map }: { map: any }) => ({
    disabled: map.general.clipboard.length <= 0,
    selected: map.general.pasteMode.activated,
});

const mapDispatchToProps = {
    onClick: actions.map.general.togglePasteMode,
};

export default connect(mapStateToProps, mapDispatchToProps)(Paste);
